import { catchError, EMPTY, firstValueFrom, map } from 'rxjs';
import { Coords, FullUser } from '../../../swagger-api';
import { MapFilters } from '../map.enum';
import { MapItemDetailsProvider } from './map-item-details.provider';

export class MapOrganizationDetailsProvider extends MapItemDetailsProvider {
  readonly filter = MapFilters.ORGANIZATIONS;

  async fetchLocationForItemById(id: string): Promise<Coords> {
    return await firstValueFrom(
      this.apiService.restUserGet(id).pipe(
        map((user: FullUser) => user.profile.location.center),
        catchError(() => EMPTY),
      ),
    );
  }

  getMarkerIdByEntityId(id: string): string {
    return id + '_organization';
  }
}
